/**
 * Form/UI sentinel for “no trim level”. MultiChoice rejects `null` option values
 * (`rejectNil`), so the form stores this string and the filter request mapper
 * converts it to `null` for the API (`trimLevel?: (string | null)[]`).
 */
export const NO_TRIM_LEVEL_OPTION = 'NO_TRIM_LEVEL' as const;

export function mapTrimLevelFormValueToRequestValue(value: string): string | null {
  return value === NO_TRIM_LEVEL_OPTION ? null : value;
}
